

import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText"; // Make sure you have access to SplitText plugin
// import img1 from "../../assets/img/hero_img_1.jpg"
// import img1 from "../../components/images/mobliehero.webp"
import img1 from "../../assets/img/ps.webp"

gsap.registerPlugin(ScrollTrigger, SplitText);






const service_data = [
  {
    id: 1,
    title: `Mobile App Development`,
    des: `We build high-performance mobile and web applications tailored to your business goals. From MVP to full-scale product, our expert team ensures seamless user experience, robust backend architecture, and scalable deployment.`,
    path : "/mobile-development",
    img:"https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    id: 2,
    title: `Software and Website Development`,
    des: `We design and develop modern, responsive, and SEO-friendly websites that engage users and convert traffic. Whether it’s a corporate site, eCommerce store, or custom portal — we deliver fast, secure, and scalable web solutions.`,
    path : "/Best-Software-Company-in-Jabalpur",
    img : "https://images.unsplash.com/photo-1678690832871-8b9993c76aa8?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    id: 3,
    title: `Digital Marketing`,
    des: `Boost your online presence with our full-suite digital services — including SEO, social media marketing, content creation, performance ads, and branding. We help you attract, engage, and convert your ideal audience.`,
    path : "Best-Digital-Marketing-Company-India",
    img : "https://images.unsplash.com/photo-1622549037543-49cf1ca0babc?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    id: 4,
    title: `Search Engine Optimisation (SEO)`,
    des: `Search engine optimization (SEO), offered by the Best SEO company, plays a major role in improving your footfalls and online presence.`,
    path : "/seo-services-india",
    img : "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    id: 5,
    title: `Graphic Designing`,
    des: `We provide all-encompassing Graphic Design Services, adeptly crafting visual creations through professionals carefully crafts captivating narratives that truly reflect the essence of your brand.`,
    path : "/graphic-designing",
    img : img1
  },
  {
    id: 6,
    title: `Social Media Marketing`,
    des: `As a social media marketing company, we bring you transformative SMM services.Come along with us on a journey where difficulties turn into learning opportunities, engagement soars, and success is within reach.`,
    path : "/Best-social-media-marketing-company-in-Jabalpur-India",
    img : "https://images.unsplash.com/photo-1643503640904-75c1a2093570?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    id: 7,
    title: `Data Analysis`,
    des: `At DoaGuru, our Data Analysis services are designed to uncover patterns, discover trends, and empower businesses with clarity, confidence, and strategic foresight.`,
    path : "/data-analysis",
    img : "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    id: 8,
    title: `PPC Google AdWords`,
    des: `Grow PPC Success: Where Clicks Result in Conversions and Victory. We are PPC experts, offering top-notch techniques that guarantee the accomplishment of your digital marketing objectives.`,
    path : "/ppc",
    img : "https://plus.unsplash.com/premium_photo-1677265808977-f28041bb2fc2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTA1fHxwYWlkJTIwcGVyJTIwY2xpY2t8ZW58MHx8MHx8fDA%3D"
  }

]



const ServiceHomeOne = () => {

    const containerRef = useRef();

  useEffect(() => {
    let ctx = gsap.context(() => {
      let splitTitleLines = gsap.utils.toArray(".anim_heading_title");

      splitTitleLines.forEach((splitTextLine) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: splitTextLine,
            start: "top 90%",
            end: "bottom 60%",
            scrub: false,
            markers: false,
            toggleActions: "play none none none",
          },
        });

        const itemSplitted = new SplitText(splitTextLine, {
          type: "words, lines",
        });

        gsap.set(splitTextLine, { perspective: 400 });

        // optional: resplit if necessary
        itemSplitted.split({ type: "lines" });

        tl.from(itemSplitted.lines, {
          duration: 1,
          delay: 0.3,
          opacity: 0,
          rotationX: -80,
          force3D: true,
          transformOrigin: "top center -50",
          stagger: 0.1,
        });
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);
  useEffect(() => {
    let ctx = gsap.context(() => {
      let splitTitleLines = gsap.utils.toArray(".anim_div_ShowDowns");

      
			splitTitleLines.forEach((showsDown) => {
				gsap.set(showsDown, {
					opacity: 0,
					y: +100,
				});
	
				gsap.to(showsDown, {
					scrollTrigger: {
						trigger: showsDown,
						start: "top 90%",
						end: "bottom 60%",
						markers: false,
					},
					opacity: 1,
					y: -0,
					ease: "power2.out",
					duration: 2,
					stagger: 1,
				});
			});
    }, containerRef);

    return () => ctx.revert();
  }, []);
  return (
    <>
    <div ref={containerRef}>
      {/* <div className="cs_height_150 cs_height_lg_60"></div> */}
      <section className="cs_primary_bg position-relative">
        <div className="cs_height_150 cs_height_lg_60"></div>
        <div className="container">
          <div className="cs_section_heading cs_style_1 cs_type_1 cs_color_1">
            <div className="cs_section_heading_text">
              <div className="cs_section_subtitle anim_div_ShowZoom">
                Our Services
              </div>
              <h2 className="cs_section_title anim_heading_title">
                Our Digital Marketing & IT Services Across India
              </h2>
            </div>
            <div className="cs_section_heading_right cs_btn_anim">
              <Link to="/services" className="cs_btn cs_style_1 cs_color_1">
                <span>View Services</span>
                <svg width="19" height="13" viewBox="0 0 19 13" view services="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.5303 7.03033C18.8232 6.73744 18.8232 6.26256 18.5303 5.96967L13.7574 1.1967C13.4645 0.903806 12.9896 0.903806 12.6967 1.1967C12.4038 1.48959 12.4038 1.96447 12.6967 2.25736L16.9393 6.5L12.6967 10.7426C12.4038 11.0355 12.4038 11.5104 12.6967 11.8033C12.9896 12.0962 13.4645 12.0962 13.7574 11.8033L18.5303 7.03033ZM0 7.25H18V5.75H0V7.25Z"
                    fill="currentColor" />
                </svg>
              </Link>
            </div>
          </div>
          <div className="cs_height_50 cs_height_lg_10"></div>
          <div className="cs_card_1_list">
            {service_data.map((item, i) => (
              <div key={i} className="cs_card cs_style_1 cs_color_1 anim_div_ShowDowns">
                <div className="cs_card_left">
                  <div className="cs_card_number cs_primary_font" style={{ backgroundImage: `url(${item.img})` }}>
                    0{i + 1}
                  </div>
                </div>
                <div className="cs_card_right">
                  <div className="cs_card_right_in">
                    <h2 className="cs_card_title">
                      <Link to={item.path}>{item.title}</Link>
                    </h2>
                    <div className="cs_card_subtitle">
                      {item.des}
                    </div>
                  </div>
                </div>
                <div className="cs_card_link_wrap">
                  <Link to={item.path} className="cs_card_link">
                    <span>
                      <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                          d="M0.340728 29.2063C0.722095 29.5875 1.34043 29.5875 1.72188 29.2063L29.0656 1.8625C29.4469 1.48106 29.4469 0.862698 29.0656 0.481253C28.6842 0.100002 28.0658 0.100002 27.6844 0.481253L0.340728 27.825C-0.0406592 28.2064 -0.0406592 28.8248 0.340728 29.2063Z"
                          fill="currentColor" />
                        <path fillRule="evenodd" clipRule="evenodd"
                          d="M28.375 26.5625C28.9143 26.5625 29.3516 26.1252 29.3516 25.5859V1.17188C29.3516 0.632618 28.9143 0.195312 28.375 0.195312H3.96094C3.42168 0.195312 2.98438 0.632618 2.98438 1.17188C2.98438 1.71113 3.42168 2.14844 3.96094 2.14844H27.3984V25.5859C27.3984 26.1252 27.8357 26.5625 28.375 26.5625Z"
                          fill="currentColor" />
                      </svg>
                    </span>
                    <span>
                      <svg width="30" height="30" viewBox="0 0 30 30" view services="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                          d="M0.340728 29.2063C0.722095 29.5875 1.34043 29.5875 1.72188 29.2063L29.0656 1.8625C29.4469 1.48106 29.4469 0.862698 29.0656 0.481253C28.6842 0.100002 28.0658 0.100002 27.6844 0.481253L0.340728 27.825C-0.0406592 28.2064 -0.0406592 28.8248 0.340728 29.2063Z"
                          view services="currentColor" />
                        <path fillRule="evenodd" clipRule="evenodd"
                          d="M28.375 26.5625C28.9143 26.5625 29.3516 26.1252 29.3516 25.5859V1.17188C29.3516 0.632618 28.9143 0.195312 28.375 0.195312H3.96094C3.42168 0.195312 2.98438 0.632618 2.98438 1.17188C2.98438 1.71113 3.42168 2.14844 3.96094 2.14844H27.3984V25.5859C27.3984 26.1252 27.8357 26.5625 28.375 26.5625Z"
                          view services="currentColor" />
                      </svg>
                    </span>
                  </Link>
                </div>
              </div>
            ))}

          </div>
        </div>
        <div className="cs_height_100 cs_height_lg_30"></div>
      </section>
</div>
    </>
  );
};

export default ServiceHomeOne;